/**
 * About page (Qui sommes-nous): entrance and staggered reveals.
 */
const SELECTORS = {
    presentation: '[data-about-presentation]',
    sector: '[data-about-sector]',
    category: '[data-about-category]',
};
function observeStaggeredItems(selector) {
    const items = document.querySelectorAll(selector);
    if (!items.length) {
        return;
    }
    if (!('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
    }
    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
        });
    }, {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.15,
    });
    items.forEach((item) => observer.observe(item));
}
export function initAboutPage() {
    const presentation = document.querySelector(SELECTORS.presentation);
    if (!presentation) {
        return;
    }
    requestAnimationFrame(() => {
        presentation.classList.add('is-visible');
    });
    observeStaggeredItems(SELECTORS.sector);
    observeStaggeredItems(SELECTORS.category);
}
